export default "__VITE_ASSET__DII0S39O__"